import React, { createContext, useEffect, useState } from "react";
import { getUserLocation } from "./utils";

// Create the context
export const LocationContext = createContext();

// Provider component
export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState({
    latitude: 45.342,
    longitude: 55.4332,
    state: "telan",
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const locationData = await getUserLocation();
        setLocation(locationData);
        // setLocation("telan");
      } catch (err) {
        setError(err);
      }
    };

    fetchLocation();
  }, []);

  return (
    <LocationContext.Provider value={{ location, error }}>
      {children}
    </LocationContext.Provider>
  );
};
